export const getLearningCenterSectionName = (name: string) => {
  const splitStr = name.toLowerCase().split(' ')
    .map(item => item.charAt(0).toUpperCase() + item.substring(1));
  return splitStr.join('');
};
